<template>
	<div id="panel_useful" class="panel announces">
		<div class="container">
			<div v-if="showMeta" class="panel_header">
				<div class="row align-items-end">
					<div class="col-12 col-lg-6">
						<h2 v-if="count">
							inTrend ({{ count }})
						</h2>
						<h2 v-else>
							inTrend
						</h2>
					</div>
				</div>
				<!--<nuxt-link class="panel_control" to="#"></nuxt-link>-->
			</div>
			<ul class="announce_list">
				<li v-for="item in listData" :key="item.id" class="row">
					<div class="col-12 col-md-4 col-lg-4 order-md-1">
						<nuxt-link
							:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
							class="announce_image_block"
						>
							<img v-if="item.listing_cover_small.src" :src="item.listing_cover_small.src" alt="">
						</nuxt-link>
					</div>
					<div class="col-12 col-md-8 col-lg-8">
						<div class="row h-100">
							<div v-if="item.date" class="col-12 col-lg-3">
								<div class="announce_date_block">
									{{ item.date | moment("DD") }} {{ item.date | moment("MMMM") }} {{ item.date | moment("YYYY") }}
								</div>
							</div>
							<div
								class="col-12 col-lg-9"
								:class="item.date ? 'col-lg-9' : 'col-lg-12'"
							>
								<div class="announce_content_block">
									<div class="announce_content_header">
										<div class="tag_string">
											<span>{{ contentTitleTypeMap[item.content_type] }}</span><template
												v-if="item.authors !== null"
											>
												<span
													v-for="author in item.authors"
													:key="author.title"
												>{{ author.title }}</span>
											</template>
										</div>
									</div>
									<div class="announce_content_middle">
										<nuxt-link
											v-if="item.issue"
											:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
											class="title announce_title"
										>
											{{ item.title }}
										</nuxt-link>

										<nuxt-link
											v-else
											:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
											class="title announce_title"
										>
											{{ item.title }}
										</nuxt-link>
										<!-- <p class="description">
											{{item.subtitle}}
										</p> -->
									</div>
									<div class="announce_content_footer">
										<nuxt-link
											v-if="item.issue"
											:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
											class="more_link"
										>
											{{ contentTypeMap[item.content_type] }}
										</nuxt-link>

										<nuxt-link
											v-else
											:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
											class="more_link"
										>
											{{ contentTypeMap[item.content_type] }}
										</nuxt-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
			<div v-if="showMeta" class="panel_footer">
				<div class="row">
					<div class="col-12 col-md-4 col-lg-2">
						<nuxt-link
							to="/navigator/content/"
							class="btn btn-primary mb-4"
						>
							Все результаты
						</nuxt-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';

export default {
	name: 'PanelUsefulList',
	props: {
		listData: { type: Array, required: true },
		category: { type: [Number, String], default: null },
		showMeta: { type: Boolean, default: false },
		count: { type: Number, default: null },
	},
	data() {
		return {
			announceMore: false,
			contentTypeMap: {
				0: 'Читать',
				1: 'Смотреть',
				2: 'Слушать',
			},
			contentTitleTypeMap: {
				0: 'Статья',
				1: 'Видео',
				2: 'Подкаст',
			},
			contentIconMap: {
				0: 'icon-text',
				1: 'icon-video',
				2: 'icon-audio',
			},
		};
	},
};
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/components/home/panel-useful-list';
</style>
